export enum ThemeDirection {
  LTR = 'ltr',
  RTL = 'rtl'
}

export interface ConfigStates {
  themeDirection: ThemeDirection;
  miniDrawer: boolean;
}

export interface ConfigContextValue {
  state: ConfigStates;
  setState: React.Dispatch<React.SetStateAction<ConfigStates>>;
  setField: <K extends keyof ConfigStates>(key: K, value: ConfigStates[K]) => void;
  resetState: () => void;
}
